import React, { useState } from "react";
import { SidePanel } from "../../../../FuturebilityCockpit/components/SidePanel";
import AxisLabels from "../AxisLabels";
import { DataPoints } from "../DataPoints";
import {
  calculatePercentageCounts,
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
  getCountsByQuadrant,
  getTopQuadrantIndex,
  QuadrantChartProps,
} from "../shared";
import "./style.scss";

export const QuadrantScatter: React.FC<QuadrantChartProps> = ({
  points,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  yTopTitle,
  yCenterTitle,
  yBottomTitle,
  xLeftTitle,
  xCenterTitle,
  xRightTitle,
  quadrantTitles,
  quadrantSidePanelTexts,
  quadrantSidePanelTitles,
}) => {
  const [hoveredQuadrantIndex, setHoveredQuadrantIndex] = useState<
    number | null
  >(null);

  const countsByQuadrant = getCountsByQuadrant(points);
  const percentagesByQuadrant = calculatePercentageCounts(countsByQuadrant);
  const topQuadrantIndex = getTopQuadrantIndex(countsByQuadrant);

  const handleQuadrantHover = (index: number | null) => {
    setHoveredQuadrantIndex(index);
  };

  return (
    <div className="quadrant-scatter-container">
      <div className="quadrant-scatter">
        <div
          className="chart-area"
          style={{
            width: `${width}px`,
            height: `${height}px`,
          }}
        >
          {quadrantTitles?.map((title, index) => (
            <div
              key={index}
              className={`quadrant with-title q${index + 1}`}
              onMouseEnter={() => handleQuadrantHover(index)}
              onMouseLeave={() => handleQuadrantHover(null)}
            >
              <div
                className={`quadrant-title ${
                  index === topQuadrantIndex ? "active" : ""
                }`}
              >
                <span>{title}</span>
              </div>
            </div>
          ))}
          <div className="quadrant-axis-y" />
          <div className="quadrant-axis-x" />
          <DataPoints points={points} width={width} height={height} />
          {hoveredQuadrantIndex !== null && (
            <SidePanel
              active
              title={quadrantSidePanelTitles[hoveredQuadrantIndex] || ""}
            >
              <div className="quadrant-overview-title">
                {percentagesByQuadrant[hoveredQuadrantIndex]}%
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M16.3175 18.0145L16.3175 16.166C16.3175 15.1856 15.928 14.2452 15.2347 13.5519C14.5413 12.8586 13.601 12.4691 12.6204 12.4691L5.22635 12.4691C4.24583 12.4691 3.30547 12.8586 2.61214 13.5519C1.91881 14.2452 1.5293 15.1856 1.5293 16.166L1.5293 18.0145"
                    stroke="#000050"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.92154 8.77353C10.9634 8.77353 12.6186 7.11835 12.6186 5.07657C12.6186 3.03479 10.9634 1.37961 8.92154 1.37961C6.87971 1.37961 5.22449 3.03479 5.22449 5.07657C5.22449 7.11835 6.87971 8.77353 8.92154 8.77353Z"
                    stroke="#000050"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div>{quadrantSidePanelTexts[hoveredQuadrantIndex]}</div>
            </SidePanel>
          )}
          <AxisLabels
            yTopTitle={yTopTitle}
            yCenterTitle={yCenterTitle}
            yBottomTitle={yBottomTitle}
            xLeftTitle={xLeftTitle}
            xCenterTitle={xCenterTitle}
            xRightTitle={xRightTitle}
          />
        </div>
      </div>
    </div>
  );
};
